module.exports = __webpack_public_path__ + "static/media/buy1.95052d37.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_190/images/buy/buy1.png
// module id = 1649
// module chunks = 0